// Gestor de Derechos de Uso — tipos de acción del árbol/reporte por carpeta.
// DES-207 ampliado.

export const GET_RIGHTS_TREE_NODE = "GET_RIGHTS_TREE_NODE";
export const GET_RIGHTS_TREE_NODE_SUCCESS = "GET_RIGHTS_TREE_NODE_SUCCESS";
export const GET_RIGHTS_TREE_NODE_FAILURE = "GET_RIGHTS_TREE_NODE_FAILURE";

export const GET_RIGHTS_SUMMARY = "GET_RIGHTS_SUMMARY";
export const GET_RIGHTS_SUMMARY_SUCCESS = "GET_RIGHTS_SUMMARY_SUCCESS";
export const GET_RIGHTS_SUMMARY_FAILURE = "GET_RIGHTS_SUMMARY_FAILURE";

export const ASSIGN_RIGHTS_MANY = "ASSIGN_RIGHTS_MANY";
export const ASSIGN_RIGHTS_MANY_SUCCESS = "ASSIGN_RIGHTS_MANY_SUCCESS";
export const ASSIGN_RIGHTS_MANY_FAILURE = "ASSIGN_RIGHTS_MANY_FAILURE";

export const REVERT_RIGHTS_OPERATION = "REVERT_RIGHTS_OPERATION";
export const REVERT_RIGHTS_OPERATION_SUCCESS = "REVERT_RIGHTS_OPERATION_SUCCESS";
export const REVERT_RIGHTS_OPERATION_FAILURE = "REVERT_RIGHTS_OPERATION_FAILURE";

export const EXPORT_RIGHTS_REPORT = "EXPORT_RIGHTS_REPORT";
export const EXPORT_RIGHTS_REPORT_SUCCESS = "EXPORT_RIGHTS_REPORT_SUCCESS";
export const EXPORT_RIGHTS_REPORT_FAILURE = "EXPORT_RIGHTS_REPORT_FAILURE";

// Vista de lista plana: se apoya en GET /rights/report, que ya devolvía filas
// paginadas y ordenables aunque hasta ahora sólo se usara para los KPI.
export const GET_RIGHTS_LIST = "GET_RIGHTS_LIST";
export const GET_RIGHTS_LIST_SUCCESS = "GET_RIGHTS_LIST_SUCCESS";
export const GET_RIGHTS_LIST_FAILURE = "GET_RIGHTS_LIST_FAILURE";

export const CLEAR_RIGHTS_ASSIGN_ERROR = "CLEAR_RIGHTS_ASSIGN_ERROR";
export const CLEAR_RIGHTS_LAST_OPERATION = "CLEAR_RIGHTS_LAST_OPERATION";

// Visor del asset dentro del Gestor. El detalle propio del módulo responde
// "por qué está en este estado", pero no muestra el archivo: la proyección del
// árbol es reducida a propósito y no trae las URLs de media. Para ver la pieza
// se reusa CollectionMiddleView —el mismo modal del repositorio— alimentado por
// este slice, igual que hacen assetsExplore, assetsFavorites y los demás.
export const OPEN_RIGHTS_VIEWER = "OPEN_RIGHTS_VIEWER";
export const OPEN_RIGHTS_VIEWER_SUCCESS = "OPEN_RIGHTS_VIEWER_SUCCESS";
export const OPEN_RIGHTS_VIEWER_FAILURE = "OPEN_RIGHTS_VIEWER_FAILURE";
export const CLOSE_RIGHTS_VIEWER = "CLOSE_RIGHTS_VIEWER";
